// src/pages/AboutUs.jsx
import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import '../css/global.css'; // Global CSS

// Import local images
import heroImage from "../assets/images/about-hero.webp";
import introImage from "../assets/images/about-intro.jpg";
import visionImage from "../assets/images/about-vision.jpg";

function AboutUs() {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section
        className="about-hero d-flex align-items-center text-center"
        style={{
          background: `linear-gradient(
              rgba(0, 0, 0, 0.6),
              rgba(0, 0, 0, 0.6)
            ), url(${heroImage}) center/cover no-repeat`,
        }}
      >
        <Container>
          <h1 className="fw-bold text-white" data-aos="fade-down">
            About Us
          </h1>
          <p className="text-white-50" data-aos="fade-up">
            Transforming dermatological care with AI and expert verification.
          </p>
        </Container>
      </section>

      {/* Intro Section */}
      <Container className="py-5">
        <Row className="align-items-center mb-5">
          <Col md={6} data-aos="fade-right">
            <img
              src={introImage}
              alt="About Pursync"
              className="img-fluid rounded shadow"
            />
          </Col>

          <Col md={6} data-aos="fade-left">
            <h2 className="fw-bold">Who We Are</h2>
            <p>
              At <b>Pursync</b>, we are passionate about transforming how people
              access dermatological care. Our mission is to harness the power of
              Artificial Intelligence to provide instant skin condition
              analysis, supported by expert dermatologists to ensure accuracy
              and trust.
            </p>
            <h4 className="fw-bold mt-4">Our Purpose</h4>
            <p>
              We aim to make skin health assessments seamless, affordable, and
              accessible, especially for communities that traditionally lack
              access to dermatological care.
            </p>
          </Col>
        </Row>

        {/* Commitment Section */}
        <Row className="text-center mt-5" data-aos="zoom-in">
          <h2 className="fw-bold mb-4">Our Commitment</h2>
          {[
            {
              icon: "fas fa-universal-access",
              title: "Accessibility",
              desc: "Bringing dermatological care to underserved communities.",
            },
            {
              icon: "fas fa-microchip",
              title: "Innovation",
              desc: "Delivering accurate insights with AI-powered tools.",
            },
            {
              icon: "fas fa-user-md",
              title: "Quality",
              desc: "Every diagnosis is verified by expert dermatologists.",
            },
            {
              icon: "fas fa-users",
              title: "Inclusion",
              desc: "Serving both rural and urban areas equally.",
            },
          ].map((item, idx) => (
            <Col md={3} sm={6} className="mb-4" key={idx}>
              <Card className="commitment-card shadow-sm border-0 h-100">
                <Card.Body>
                  <div className="icon-circle bg-primary text-white mb-3 mx-auto">
                    <i className={item.icon}></i>
                  </div>
                  <h5 className="fw-bold">{item.title}</h5>
                  <p className="small text-muted">{item.desc}</p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Vision Section */}
        <Row className="align-items-center mt-5">
          <Col md={6} data-aos="fade-right">
            <h2 className="fw-bold">Our Vision</h2>
            <p>
              We envision a future where no one is left behind in accessing
              skin healthcare. By combining cutting-edge AI technology with
              medical expertise, we aim to empower individuals worldwide with
              reliable, instant, and affordable dermatological solutions.
            </p>
          </Col>
          <Col md={6} data-aos="fade-left">
            <img
              src={visionImage}
              alt="Vision"
              className="img-fluid rounded shadow"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AboutUs;
